// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 351) return "static/chunks/commons-fa6188b8445b24a6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "33b01d75709ed288" + ".js";
};